export default __webpack_public_path__ + "static/media/logo2.fc9b42b9.svg";